var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  Use Cases library for the thisNode entity.
*/
var ThisNodeEntity = require('../entities/this-node-entity');

var Schema = require('../adapters/schema'); // A global variable that maintains scope to the instance of this class, when
// the context of 'this' is lost.


var _this;

var ThisNodeUseCases = /*#__PURE__*/function () {
  "use strict";

  function ThisNodeUseCases() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ThisNodeUseCases);

    // Dependency Injection.
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Must inject instance of adapters when instantiating thisNode Use Cases library.');
    }

    this.controllers = localConfig.controllers;

    if (!this.controllers) {
      throw new Error('Must inject instance of controllers when instantiating thisNode Use Cases library.');
    } // Optional JSON-LD used for announcements. If present, will override
    // default announcement object in Schema library.


    this.announceJsonLd = localConfig.announceJsonLd; // If consuming app wants to configure itself as a Circuit Relay, it can
    // override the default value of false.

    this.isCircuitRelay = localConfig.isCircuitRelay;
    if (!this.isCircuitRelay) this.isCircuitRelay = false; // Additional information for connecting to the circuit relay.

    this.circuitRelayInfo = localConfig.circuitRelayInfo;
    _this = this;
  } // Update this instance with copies of the other Use Case libraries.


  _createClass(ThisNodeUseCases, [{
    key: "updateUseCases",
    value: function updateUseCases(useCaseParent) {
      this.useCases = {
        relays: useCaseParent.relays,
        pubsub: useCaseParent.pubsub,
        peer: useCaseParent.peer
      };
    } // Create an instance of the 'self' of thisNode. This function aggregates
    // a lot of information pulled from the different adapters.

  }, {
    key: "createSelf",
    value: function () {
      var _createSelf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var initValues,
            selfData,
            bchData,
            schemaConfig,
            thisNode,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initValues = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                selfData = {
                  // The type of IPFS node this is: browser or node.js
                  type: initValues.type
                }; // Aggregate data from the IPFS adapter.

                selfData.ipfsId = this.adapters.ipfs.ipfsPeerId;
                selfData.ipfsMultiaddrs = this.adapters.ipfs.ipfsMultiaddrs; // Aggregate data from the BCH adapter.

                _context.next = 6;
                return this.adapters.bch.generateBchId();

              case 6:
                bchData = _context.sent;
                selfData.bchAddr = bchData.cashAddress;
                selfData.slpAddr = bchData.slpAddress;
                selfData.publicKey = bchData.publicKey; // selfData.mnemonic = this.adapters.bch.mnemonic
                // Generate an OrbitDB for other peers to pass messages to this node.
                // TODO: deprecate
                // selfData.orbit = await this.adapters.orbit.createRcvDb(selfData)

                schemaConfig = {
                  ipfsId: selfData.ipfsId,
                  type: selfData.type,
                  ipfsMultiaddrs: selfData.ipfsMultiaddrs,
                  isCircuitRelay: this.isCircuitRelay,
                  circuitRelayInfo: this.circuitRelayInfo,
                  cashAddress: selfData.bchAddr,
                  slpAddress: selfData.slpAddr,
                  publicKey: selfData.publicKey,
                  // orbitdbId: selfData.orbit.id,
                  // apiInfo: '',
                  announceJsonLd: this.announceJsonLd
                };
                selfData.schema = new Schema(schemaConfig); // console.log('selfData: ', selfData)
                // Create the thisNode entity

                thisNode = new ThisNodeEntity(selfData);
                this.thisNode = thisNode; // Attach ther useCases (which includes adapters and controllers) to the
                // thisNode entity.

                this.thisNode.useCases = this.useCases; // Subscribe to my own pubsub channel, for receiving info from other peers.

                _context.next = 17;
                return this.adapters.pubsub.subscribeToPubsubChannel(selfData.ipfsId, this.tempHander, this.thisNode);

              case 17:
                selfData.pubsub = _context.sent;
                return _context.abrupt("return", thisNode);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createSelf() {
        return _createSelf.apply(this, arguments);
      }

      return createSelf;
    }() // This is an event handler that is triggered by a new announcement object
    // being recieved on the general coordination pubsub channel.
    // pubsub-use-cases.js/initializePubSub() depends on this function.

  }, {
    key: "addSubnetPeer",
    value: function () {
      var _addSubnetPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(announceObj) {
        var thisPeerId, now, thisPeerData, dataIndex, oldBroadcastDate, newBroadcastDate;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (_this.isFreshPeer(announceObj)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                thisPeerId = announceObj.from.toString();

                _this.adapters.log.statusLog(2, "announcement recieved from ".concat(thisPeerId));

                _this.adapters.log.statusLog(3, "announcement recieved from ".concat(thisPeerId, ": "), announceObj); // console.log('_this.thisNode.peerList: ', _this.thisNode.peerList)
                // Add a timestamp.


                now = new Date();
                announceObj.data.updatedAt = now.toISOString(); // If the peer is not already in the list of known peers, then add it.

                if (_this.thisNode.peerList.includes(thisPeerId)) {
                  _context3.next = 19;
                  break;
                }

                _this.adapters.log.statusLog(0, "New peer found: ".concat(thisPeerId)); // Add this peer to the list of subnet peers tracked by this node.


                _this.thisNode.peerList.push(thisPeerId); // Add the announcement data object to the peerData array tracked by This Node.


                _this.thisNode.peerData.push(announceObj); // Subscribe to pubsub channel for private messages to peer.
                // Ignore any messages on this channel, since it is only used for
                // broadcasting encrypted messages to the new peer, and they will
                // respond on our own channel.


                _context3.next = 14;
                return _this.adapters.ipfs.ipfs.pubsub.subscribe(thisPeerId, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(msg) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 14:
                if (!announceObj.data.isCircuitRelay) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 17;
                return _this.useCases.relays.addRelay(thisPeerId, _this.thisNode);

              case 17:
                _context3.next = 27;
                break;

              case 19:
                // Peer already exists in the list.
                // console.log(`debug: Updating existing peer: ${thisPeerId}`)
                // Get the data for this peer.
                thisPeerData = _this.thisNode.peerData.filter(function (x) {
                  return x.from === thisPeerId;
                });
                thisPeerData = thisPeerData[0];
                dataIndex = _this.thisNode.peerData.indexOf(thisPeerData); // console.log(`dataIndex: ${dataIndex}`)
                // If the new announceObj is older than the last announceObj, then
                // ignore it.

                oldBroadcastDate = new Date(thisPeerData.data.broadcastedAt);
                newBroadcastDate = new Date(announceObj.data.broadcastedAt);

                if (!(newBroadcastDate.getTime() < oldBroadcastDate.getTime())) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", true);

              case 26:
                // Replace the old data with the new data.
                _this.thisNode.peerData[dataIndex] = announceObj; // console.log('announceObj.data.orbitdb: ', announceObj.data.orbitdb)
                // console.log('thisPeerData: ', thisPeerData)
                // Update the connection to the peers OrbitDB, if needed.
                // const announceOrbitId = announceObj.data.orbitdb
                // const peerOrbitId = thisPeerData.data.orbitdb
                // if (!announceOrbitId.includes(peerOrbitId)) {
                //   // console.log(`debug: Switching to new OrbitDB for known peer: ${announceOrbitId}`)
                //   _this.adapters.log.statusLog(
                //     0,
                //     `debug: Switching to new OrbitDB for known peer: ${announceOrbitId}`
                //   )
                //   // console.log(
                //   //   `debug: announceObj: ${JSON.stringify(announceObj, null, 2)}`
                //   // )
                //
                //   await _this.adapters.orbit.connectToPeerDb({
                //     peerId: announceObj.from,
                //     orbitdbId: announceObj.data.orbitdb,
                //     thisNode: _this.thisNode
                //   })
                // }

              case 27:
                return _context3.abrupt("return", true);

              case 30:
                _context3.prev = 30;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in this-node-use-cases.js/addSubnetPeer(): ', _context3.t0);

                _this.adapters.log.statusLog(2, 'Error in this-node-use-cases.js/addSubnetPeer(): ', _context3.t0); // Do not throw an error. This is a top-level function called by the
                // pubsub handler for the general coordination channel.


              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 30]]);
      }));

      function addSubnetPeer(_x) {
        return _addSubnetPeer.apply(this, arguments);
      }

      return addSubnetPeer;
    }() // Detects if a peer has gone 'stale' (inactive), or is still 'fresh' (active).
    // Stale means it hasn't updated it's
    // broadcastedAt property in more than 10 minutes.
    // Return true if the peer is 'fresh', and false if 'stale'.

  }, {
    key: "isFreshPeer",
    value: function isFreshPeer(announceObj) {
      try {
        // Ignore announcements that do not have a broadcastedAt timestamp.
        if (!announceObj.data.broadcastedAt) return false; // Ignore items that are older than 10 minutes.

        var now = new Date();
        var broadcastTime = new Date(announceObj.data.broadcastedAt);
        var tenMinutes = 60000 * 10;
        var timeDiff = now.getTime() - broadcastTime.getTime();
        if (timeDiff > tenMinutes) return false;
        return true;
      } catch (err) {
        console.error('Error in stalePeer()');
        throw err;
      }
    } // Called by an Interval, ensures connections are maintained to known pubsub
    // peers. This will heal connections if nodes drop in and out of the network.

  }, {
    key: "refreshPeerConnections",
    value: function () {
      var _refreshPeerConnections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var relays, peers, connectedPeers, _loop, i, _ret, now;

        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                // console.log('this.thisNode: ', this.thisNode)
                // const relays = this.cr.state.relays
                relays = this.thisNode.relayData;
                peers = this.thisNode.peerList; // console.log('peers: ', peers)
                // Get connected peers

                _context5.next = 5;
                return this.adapters.ipfs.getPeers();

              case 5:
                connectedPeers = _context5.sent;
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                  var thisPeer, connectedPeer, peerData, sortedRelays, _i, thisRelay, multiaddr, connected;

                  return _regeneratorRuntime.wrap(function _loop$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          // const thisPeer = this.state.peers[peer]
                          thisPeer = peers[i]; // console.log(`thisPeer: ${JSON.stringify(thisPeer, null, 2)}`)
                          // Check if target peer is currently conected to the node.

                          connectedPeer = connectedPeers.filter(function (peerObj) {
                            return peerObj.peer === thisPeer;
                          }); // console.log('connectedPeer: ', connectedPeer)
                          // If this node is already connected to the peer, then skip this peers.
                          // We do not need to do anything.

                          if (!connectedPeer.length) {
                            _context4.next = 5;
                            break;
                          }

                          _this2.adapters.log.statusLog(2, "Skipping peer in refreshPeerConnections(). Already connected to peer ".concat(thisPeer));

                          return _context4.abrupt("return", "continue");

                        case 5:
                          // Get the peer data for the current peer.
                          peerData = _this2.thisNode.peerData.filter(function (x) {
                            return x.from.includes(thisPeer);
                          });
                          peerData = peerData[0]; // console.log('peerData: ', peerData)
                          // TODO: if broadcastedAt value is older than 10 minutes, skip connecting
                          // to the peer. It may be stale information.

                          if (_this2.isFreshPeer(peerData)) {
                            _context4.next = 10;
                            break;
                          }

                          _this2.adapters.log.statusLog(2, "Peer ".concat(peerData.from, " is stale. Skipping."));

                          return _context4.abrupt("return", "continue");

                        case 10:
                          // Sort the Circuit Relays by the average of the aboutLatency
                          // array. Connect to peers through the Relays with the lowest latencies
                          // first.
                          sortedRelays = _this2.thisNode.useCases.relays.sortRelays(relays); // console.log(`sortedRelays: ${JSON.stringify(sortedRelays, null, 2)}`)
                          // Loop through each known circuit relay and attempt to connect to the
                          // peer through a relay.

                          _i = 0;

                        case 12:
                          if (!(_i < sortedRelays.length)) {
                            _context4.next = 24;
                            break;
                          }

                          thisRelay = sortedRelays[_i]; // console.log(`thisRelay: ${JSON.stringify(thisRelay, null, 2)}`)
                          // Generate a multiaddr for connecting to the peer through a circuit relay.

                          multiaddr = "".concat(thisRelay.multiaddr, "/p2p-circuit/p2p/").concat(thisPeer); // console.log(`multiaddr: ${multiaddr}`)
                          // Skip the relay if this node is not connected to it.

                          if (!thisRelay.connected) {
                            _context4.next = 21;
                            break;
                          }

                          _context4.next = 18;
                          return _this2.adapters.ipfs.connectToPeer(multiaddr);

                        case 18:
                          connected = _context4.sent;

                          if (!connected) {
                            _context4.next = 21;
                            break;
                          }

                          return _context4.abrupt("break", 24);

                        case 21:
                          _i++;
                          _context4.next = 12;
                          break;

                        case 24:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 8:
                if (!(i < peers.length)) {
                  _context5.next = 16;
                  break;
                }

                return _context5.delegateYield(_loop(i), "t0", 10);

              case 10:
                _ret = _context5.t0;

                if (!(_ret === "continue")) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("continue", 13);

              case 13:
                i++;
                _context5.next = 8;
                break;

              case 16:
                now = new Date();
                this.adapters.log.statusLog(2, "Renewed connections to all known peers at ".concat(now.toLocaleString()));
                return _context5.abrupt("return", true);

              case 21:
                _context5.prev = 21;
                _context5.t1 = _context5["catch"](0);
                console.error('Error in refreshPeerConnections()');
                throw _context5.t1;

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this, [[0, 21]]);
      }));

      function refreshPeerConnections() {
        return _refreshPeerConnections.apply(this, arguments);
      }

      return refreshPeerConnections;
    }() // Enforce the blacklist by actively disconnecting from nodes in the blacklist.

  }, {
    key: "enforceBlacklist",
    value: function () {
      var _enforceBlacklist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var blacklistPeers, i, ipfsId, blacklistMultiaddrs, _i2, multiaddr;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                blacklistPeers = this.thisNode.blacklistPeers;
                i = 0;

              case 3:
                if (!(i < blacklistPeers.length)) {
                  _context6.next = 10;
                  break;
                }

                ipfsId = blacklistPeers[i];
                _context6.next = 7;
                return this.adapters.ipfs.disconnectFromPeer(ipfsId);

              case 7:
                i++;
                _context6.next = 3;
                break;

              case 10:
                blacklistMultiaddrs = this.thisNode.blacklistMultiaddrs;
                _i2 = 0;

              case 12:
                if (!(_i2 < blacklistMultiaddrs.length)) {
                  _context6.next = 19;
                  break;
                }

                multiaddr = blacklistMultiaddrs[_i2];
                _context6.next = 16;
                return this.adapters.ipfs.disconnectFromMultiaddr(multiaddr);

              case 16:
                _i2++;
                _context6.next = 12;
                break;

              case 19:
                return _context6.abrupt("return", true);

              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6["catch"](0);
                console.error('Error in enforceBlacklist()');
                throw _context6.t0;

              case 26:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this, [[0, 22]]);
      }));

      function enforceBlacklist() {
        return _enforceBlacklist.apply(this, arguments);
      }

      return enforceBlacklist;
    }() // An alternative to the blacklist, it's a whitelist, where all nodes are
    // disconnected except ones that have a 'name' property. This ensures that
    // the node only connects to other nodes that are using ipfs-coord.

  }, {
    key: "enforceWhitelist",
    value: function () {
      var _enforceWhitelist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;

        var showDebugData, allPeers, coordPeers, _loop2, i;

        return _regeneratorRuntime.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                showDebugData = false; // Get all peers.

                _context8.next = 4;
                return this.adapters.ipfs.getPeers();

              case 4:
                allPeers = _context8.sent;
                // console.log(`allPeers: ${JSON.stringify(allPeers, null, 2)}`)
                // Get ipfs-coord peers.
                coordPeers = this.thisNode.peerData; // console.log(`coordPeers: ${JSON.stringify(coordPeers, null, 2)}`)
                // Try to match each peer up with ipfs-coord info.
                // Add the name from the ipfs-coord info.

                _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2(i) {
                  var thisPeer, foundPeer;
                  return _regeneratorRuntime.wrap(function _loop2$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          thisPeer = allPeers[i];
                          thisPeer.name = ''; // If IPFS peer exists in the ipfs-coord peer list, then foundPeer
                          // will be an array with 1 element.

                          foundPeer = coordPeers.filter(function (x) {
                            return x.from.toString().includes(thisPeer.peer.toString());
                          }); // If a connected peer matches an ipfs-coord peer, add the 'name'
                          // property to it.

                          if (foundPeer.length) {
                            _context7.next = 8;
                            break;
                          }

                          _this3.adapters.log.statusLog(2, "Whitelist enforcement disconnecting peer ".concat(thisPeer.peer.toString()));

                          showDebugData = true; // If a connected peer can not be matched with the list of ipfs-coord
                          // peers, then disconnect from it.

                          _context7.next = 8;
                          return _this3.adapters.ipfs.disconnectFromPeer(thisPeer.peer.toString());

                        case 8:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _loop2);
                });
                i = 0;

              case 8:
                if (!(i < allPeers.length)) {
                  _context8.next = 13;
                  break;
                }

                return _context8.delegateYield(_loop2(i), "t0", 10);

              case 10:
                i++;
                _context8.next = 8;
                break;

              case 13:
                // Show the debugging data once, instead of inside the for-loop, which would
                // show the debugging data each time a peer is disconnected.
                if (showDebugData) {
                  // Deep debugging.
                  this.adapters.log.statusLog(3, "allPeers: ".concat(JSON.stringify(allPeers, null, 2)));
                  this.adapters.log.statusLog(3, "coordPeers: ".concat(JSON.stringify(coordPeers, null, 2)));
                }

                return _context8.abrupt("return", true);

              case 17:
                _context8.prev = 17;
                _context8.t1 = _context8["catch"](0);
                console.error('Error in enforceWhitelist()');
                throw _context8.t1;

              case 21:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee6, this, [[0, 17]]);
      }));

      function enforceWhitelist() {
        return _enforceWhitelist.apply(this, arguments);
      }

      return enforceWhitelist;
    }()
  }]);

  return ThisNodeUseCases;
}();

module.exports = ThisNodeUseCases;